// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"3e98df60","557":"b5bbf650","613":"9f78e607","707":"a01ff210"}[chunkId] + ".chunk.js";
};